import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
// eslint-disable-next-line max-len
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import { OptionsHOC } from '../../hocs'

const SEO = ({
  children,
  location,
  description = '',
  title,
  image,
  language,
  script,
  getOption
}) => {
  const keywords = description ? description.split(' ').join(', ') : ''

  return (
    <Helmet titleTemplate={`%s - ${getOption('pageTitle')}`}>
      <html lang={language} />
      <title>{title}</title>
      <If condition={getOption('favicon')}>
        <link
          href={getOption('favicon')}
          rel="shortcut icon"
          type="image/x-icon"
        />
      </If>
      <link
        rel="alternate"
        href={`${window.location.href}`}
        hrefLang="en-us"
        key="en-us"
      />
      <link
        rel="alternate"
        href={`${window.location.href}?lang=es-ud`}
        hrefLang="es-US"
        key="es-US"
      />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
      <meta httpEquiv="Content-Type" content="text/html;charset=UTF-8" />
      <meta property="description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en-us" />
      <meta property="og:locale:alternate" content="es-US" />
      {location && <meta property="og:url" content={location.href} />}
      <meta
        property="og:image"
        content={image || getOption('header.headerLogo')}
      />
      <meta property="og:title" content={title} key="ogtitle" />
      <meta property="og:description" content={description} key="ogdesc" />
      <meta property="fb:app_id" content={getOption('app_id')} />

      <meta
        className="swiftype"
        name="body"
        data-type="text"
        content={description}
      />
      <meta
        className="swiftype"
        name="title"
        data-type="text"
        content={title}
      />
      <meta
        className="swiftype"
        name="languagePages"
        data-type="text"
        content={language}
      />
      <meta
        className="swiftype"
        name="description"
        data-type="text"
        content={description}
      />
      <meta
        className="swiftype"
        name="keywords"
        data-type="text"
        content={keywords}
      />

      <script type="application/ld+json">{script}</script>
      {children}
    </Helmet>
  )
}

SEO.propTypes = {
  children: PropTypes.node,
  location: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string,
  language: PropTypes.string,
  script: PropTypes.string,
  getOption: PropTypes.func
}

SEO.defaultProps = {
  children: null,
  location: '',
  description: '',
  title: '',
  image: '',
  language: '',
  script: '',
  getOption: () => {}
}

export default LanguageProvider(OptionsHOC(SEO))



// WEBPACK FOOTER //
// ./src/components/SEO/index.js